// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"574":"2a53c843","630":"dd33944e"}[chunkId] + ".chunk.css";
};